// extracted by mini-css-extract-plugin
export var active = "_o-9";
export var backButton = "_o-8";
export var clone = "_o-e";
export var collapseBar = "_o-k";
export var collapseMode = "_o-m";
export var collapsed = "_o-o";
export var dimmed = "_o-i";
export var dragHandle = "_o-c";
export var dropdownIcon = "_o-g";
export var expanding = "_o-n";
export var hidden = "_o-x";
export var iconContainer = "_o-q";
export var iconSwapper = "_o-w";
export var navItem = "_o-6";
export var navItemIcon = "_o-f";
export var navProfile = "_o-7";
export var notificationCountBadge = "_o-j";
export var notificationDot = "_o-r";
export var optionsContainer = "_o-h";
export var primaryNav = "_o-0";
export var primaryNavDivider = "_o-v";
export var primaryNavResizeHandle = "_o-2";
export var primaryNavResizing = "_o-1";
export var primaryNavTabSection = "_o-u";
export var primaryTab = "_o-p";
export var primaryTabIconBox = "_o-s";
export var secondaryNav = "_o-3";
export var selected = "_o-t";
export var settingsNav = "_o-4";
export var settingsNavItems = "_o-5";
export var show = "_o-d";
export var sideNav = "_o-l";
export var teamItem = "_o-a";
export var userProfileItem = "_o-b";